import React, { useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';
import { CustomAlert, showToastAlert } from "../../admin/components/CustomAlert";
import { addCompany, updateCompany } from "../../services/writerPost";
import { useSelector } from 'react-redux';


const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 300,
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};


export function CompanyModal({ open, onClose, onCreate, onUpdate, company = null }) {
    const [companyName, setCompanyName] = useState('');
    const [logoPath, setLogoPath] = useState('');
    const [linkedinUrl, setLinkedinUrl] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const token = useSelector(state => state.token);

    React.useEffect(() => {
      if (company  && typeof company === 'object') {
        setCompanyName(company.name);
        setLogoPath(company.logo);
        setLinkedinUrl(company.lUrl);
      } else {
        setCompanyName("");
        setLogoPath("");
        setLinkedinUrl("");
      }
    }, [company]);

    const handleCreate = async () => {
      if ( !companyName || !companyName.trim() || !linkedinUrl || !linkedinUrl.trim()) {
        window.alert("Please fill all required fields");
        return;
      }
      setError(null);
      try {
        let response = null;
        //add https if not present in linkedinUrl
        let finalLinkedinUrl = linkedinUrl.trim();
        if(!linkedinUrl.startsWith("http://") && !linkedinUrl.startsWith("https://")) {
          finalLinkedinUrl = "https://" + finalLinkedinUrl;
        }
        if(company != null) 
          response = await updateCompany(token, company._id, companyName, logoPath, finalLinkedinUrl);
        else
          response  = await addCompany(token, companyName, logoPath, finalLinkedinUrl);


        if(response.status !== 200) {
          showToastAlert(response.data.message, "error");
          return;
        }
        if(company != null)
          onUpdate();
        else
          onCreate();
        setCompanyName("");
        setLogoPath("");
        setLinkedinUrl("");
        setError(null);
        setLoading(false);
        onClose();
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
  
    return (
      <Modal open={open} onClose={onClose}>
        <Box sx={style}>
          <Typography variant="h6" component="h2" gutterBottom>
            New Company
          </Typography>
          <TextField
            label="Company Name"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            fullWidth
            sx={{ mb: 2 }}
          />
          <TextField
          label="Logo Path"
          value={logoPath}
          onChange={(e) => setLogoPath(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
        />
        <TextField
          label="Linkedin Url"
          value={linkedinUrl}
          onChange={(e) => setLinkedinUrl(e.target.value)}
          fullWidth
          sx={{ mb: 2 }}
          required
        />
          {error && <Typography color="error" sx={{ mb: 1 }}>{error}</Typography>}
          <Button variant="contained" onClick={handleCreate} fullWidth>{company ? "Update" : "Create"}</Button>
        </Box>
      </Modal>
    );
  }
  